module.exports = __webpack_public_path__ + "static/media/affiliateBanner-mcf.cdffef04.jpg";